(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playio-brand-values"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pbvInit === '1') return;
      root.dataset.pbvInit = '1';
      var items = root.querySelectorAll('.playio-brand-values__item');
      if (items.length < 2) return;
      var speed = parseInt(root.dataset.pbvAutoplayMs, 10);
      if (isNaN(speed)) speed = 4000;
      if (speed < 2000) speed = 2000;
      if (speed > 10000) speed = 10000;
      var idx = 0;
      var mq = window.matchMedia('(max-width: 749px)');
      function setActive(i) {
        for (var j = 0; j < items.length; j++) {
          items[j].classList.toggle('is-active', j === i);
        }
      }
      function tick() {
        if (!mq.matches) return;
        idx = (idx + 1) % items.length;
        setActive(idx);
      }
      setActive(idx);
      var timer = setInterval(tick, speed);
      function onChange() {
        if (!mq.matches) {
          idx = 0;
          setActive(idx);
        }
      }
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
    function boot() {
      document.querySelectorAll('.playio-brand-values').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playio-reviews-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.playioReviewsInit === '1') return;
      root.dataset.playioReviewsInit = '1';
      var track = root.querySelector('[data-playio-reviews-track]');
      var prev = root.querySelector('.playio-reviews-home__nav--prev');
      var next = root.querySelector('.playio-reviews-home__nav--next');
      if (!track || !prev || !next) return;

      function scrollStep() {
        var card = track.querySelector('.playio-reviews-home__card');
        if (!card) return 320;
        // Use bounding rect width + gap (20px) for snap step
        return card.getBoundingClientRect().width + 20;
      }

      function update() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 2);
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function boot() {
      document.querySelectorAll('[data-playio-reviews]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
